import type {
  ConfiguracaoEmpresaInputType,
  ConfiguracaoEmpresaOutputType,
  UsuarioCreateInputType,
  UsuarioOutputType,
  UsuarioUpdateInputType,
} from '../../../shared/dto';
import { callApi } from './call-api';

export const usuariosApi = {
  listar: (_args: void) => callApi<UsuarioOutputType[]>({ path: '/usuarios' }),

  criar: (body: UsuarioCreateInputType) =>
    callApi<UsuarioOutputType>({
      method: 'POST',
      path: '/usuarios',
      body,
    }),

  atualizar: ({ id, dados }: { id: string; dados: UsuarioUpdateInputType }) =>
    callApi<UsuarioOutputType>({
      method: 'PUT',
      path: `/usuarios/${id}`,
      body: dados,
    }),

  atualizarNomeEmpresa: (body: ConfiguracaoEmpresaInputType) =>
    callApi<ConfiguracaoEmpresaOutputType>({
      method: 'PUT',
      path: '/configuracoes/empresa',
      body,
    }),
};
